import React from 'react';
import {Rnd} from 'react-rnd';
import styled from 'styled-components';
import RoundButton from '../../components/roundButton';
import EventReportContainer from '../../containers/report-container/EventReportContainer';
import RouteReportContainer from '../../containers/report-container/RouteReportContainer';
import StopReportContainer from '../../containers/report-container/StopReportContainer';
import SummaryReportContainer from '../../containers/report-container/SummaryReportContainer';
import TripReportContainer from '../../containers/report-container/TripReportContainer';
import JourneyReportContainer from '../../containers/report-container/JourneyReportContainer';
import CertadocFineReportContainer from '../../containers/report-container/CertadocFineReportContainer';

const Styles = styled.div`
  .drag-handle {
    cursor: move;
  }
  .container-fluid {
    padding: 0 !important;
  }
  .custom-shadow-2 {
    position: relative !important;
    width: 100% !important;
    bottom: 0 !important;
  }

  button {
    &.rounded-circle {
      position: absolute !important;
      align-self: flex-end !important;
      z-index: 1 !important;
      top: -0.9em !important;
      right: -1.6rem !important;
    }
  }
`;

export const REPORT_PANEL_Z_INDEX = 1030;

const FloatingReport = ({type, location, close, mapRef}) => {
  return (
    <Rnd
      // abaixo do backdrop do modal (1040) e acima do mapa e da legenda (ate 999),
      // senao o painel cobre a selecao de relatorio aberta pelo botao do cabecalho
      style={{zIndex: REPORT_PANEL_Z_INDEX}}
      default={{x: 100, y: 100, width: 600, height: 302}}
      minWidth={600}
      minHeight={302}
      maxHeight={302}
      bounds="window"
      dragHandleClassName="drag-handle">
      <Styles>
        {type && (
          <RoundButton className="mt-3" onClick={close}>
            <span className="fas fa-times text-secondary" />
          </RoundButton>
        )}
        <div>
          {
            {
              route: (
                <RouteReportContainer
                  mapRef={mapRef}
                  location={location}
                  listOnly={true}
                />
              ),
              event: (
                <EventReportContainer
                  mapRef={mapRef}
                  location={location}
                  listOnly={true}
                />
              ),
              trip: (
                <TripReportContainer
                  mapRef={mapRef}
                  location={location}
                  listOnly={true}
                />
              ),
              stop: (
                <StopReportContainer
                  mapRef={mapRef}
                  location={location}
                  listOnly={true}
                />
              ),
              summary: (
                <SummaryReportContainer location={location} listOnly={true} />
              ),
              journey: (
                <JourneyReportContainer
                  mapRef={mapRef}
                  location={location}
                  listOnly={true}
                />
              ),
              certadocfines: (
                <CertadocFineReportContainer location={location} listOnly={true} />
              ),
            }[type]
          }
        </div>
      </Styles>
    </Rnd>
  );
};

export default FloatingReport;
